export class ChatClass {
    constructor() {
        this.id = 0;
        this.cuid = "";
        this.sender = "";
        this.receiver = "";
    }
}